import { SocialsButtons } from './social-buttons';

export default SocialsButtons;
